import React from 'react';
import './Badge.less';


export const BadgeStyles = {
	ERROR: 'ERROR',
	WARNING: 'WARNING',
	SUCCESS: 'SUCCESS',
	DISABLED: 'DISABLED'
}

export const Badge = ({text, style}) => {
	return <div className={`badge ${
		style === BadgeStyles.WARNING ? 'badge--warning' : ''
	} ${
		style === BadgeStyles.DISABLED ? 'badge--disabled' : ''
	} ${
		style === BadgeStyles.SUCCESS ? 'badge--success' : ''
	} ${
		style === BadgeStyles.ERROR ? 'badge--error' : ''
	}`}>{text}</div>
}
